import React from 'react'
import { makeStyles } from '@mui/styles'
import { PrimaryButton } from '../components/restyled-mui/CustomButton'

const useStyles = makeStyles(theme => ({
  centered: {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
}))

const PageNotFound = props => {
  const classes = useStyles(props)
  const { goToHomepage } = props

  return (
    <div className={classes.centered}>
      <PrimaryButton onClick={goToHomepage}>Front page</PrimaryButton>
    </div>
  )
}

export default PageNotFound
